var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.63 432.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#e0e0e0;}.cls-3,.cls-8{fill:none;}.cls-4{fill:#f0f0f0;}.cls-5{isolation:isolate;}.cls-6{fill:#ebebeb;}.cls-7{fill:#fafafa;}.cls-8{stroke:gray;stroke-linecap:round;stroke-linejoin:round;stroke-width:0;}.cls-14,.cls-17,.cls-24,.cls-9{fill:#fff;}.cls-10{fill:#cacaca;}.cls-11{opacity:0.15;}.cls-12{fill:#ba68c8;}.cls-13,.cls-14,.cls-22{opacity:0.2;}.cls-15,.cls-24{opacity:0.1;}.cls-16{fill:#455a64;}.cls-17,.cls-19,.cls-26{opacity:0.3;}.cls-18,.cls-28{opacity:0.4;}.cls-20{opacity:0.6;}.cls-21{opacity:0.7;}.cls-23{fill:#37474f;}.cls-25{fill:#ffa8a7;}.cls-27{fill:#263238;}.cls-29{fill:#f28f8f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "crypto svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.32,247.87c-90.23-52.1-236-52.1-325.7,0s-89.18,136.56,1,188.66,236.07,52.1,325.72,0S502.56,300,412.32,247.87Z",
    transform: "translate(-19.69 -42.91)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.93,357.72c6.67-3.86,17.46-3.86,24.09,0s6.59,10.1-.08,13.95-17.46,3.86-24.09,0S41.25,361.57,47.93,357.72Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.12,330.2c7-4,18.31-4,25.27,0s6.91,10.59-.08,14.63-18.32,4-25.27,0S432.12,334.24,439.12,330.2Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "309.02 217.73 52.66 367.43 41.8 361.16 298.16 211.46 309.02 217.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.87,340c-25-14.43-65.37-14.43-90.19,0-21.94,12.74-24.37,32.48-7.41,46.86-13.69-.85-27.87,1.76-38.32,7.83-18.35,10.66-18.25,27.95.21,38.61s48.31,10.66,66.65,0c14.6-8.48,17.51-21.16,8.79-31.35,21,3,44.18-.19,60.56-9.71C422,377.84,421.86,354.45,396.87,340Z",
    transform: "translate(-19.69 -42.91)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Pictures"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.41 50.36 59.32 70.61 59.4 97.43 94.48 77.17 94.41 50.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "94.41 50.36 94.48 77.17 97.73 79.06 97.65 48.49 94.41 50.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.4 97.43 59.41 101.19 97.73 79.06 94.48 77.17 59.4 97.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.25,84.63,75.07,111.29l.11,39.59,46.18-26.66ZM79.1,144.1v-3.76L79,113.53l35.08-20.26,3.24-1.87.09,30.57Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "101.56 41.71 98.31 39.83 52.13 66.48 55.38 68.37 101.56 41.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "52.13 66.48 52.25 106.08 55.5 107.96 55.38 68.37 52.13 66.48"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.26 60.54 92.83 68.07 92.85 75.43 61.03 93.8 61.01 86.44 67.07 74.4 72.52 78.63 70.59 84.61 73.39 79.3 83.26 60.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.49,107.16c1.5-.86,2.72-.17,2.73,1.55a6,6,0,0,1-2.71,4.68c-1.5.87-2.71.17-2.72-1.55A6,6,0,0,1,92.49,107.16Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "369.96 126.65 405.05 146.9 404.97 173.72 369.89 153.46 369.96 126.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "369.96 126.65 369.89 153.46 366.64 155.35 366.73 124.78 369.96 126.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "404.97 173.72 404.96 177.48 366.64 155.35 369.89 153.46 404.97 173.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.39,200.51l46.17,26.66.11-39.59L382.5,160.92Zm3.94-2.25.08-30.57,3.24,1.87,35.08,20.26-.07,26.81v3.76Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "362.81 118 366.06 116.12 412.24 142.78 408.99 144.66 362.81 118"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "412.24 142.78 412.13 182.37 408.88 184.26 408.99 144.66 412.24 142.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "381.11 136.83 371.54 144.36 371.52 151.72 403.35 170.09 403.37 162.74 397.3 150.69 391.86 154.92 393.78 160.9 390.99 155.59 381.11 136.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.25,183.45c-1.5-.86-2.72-.17-2.72,1.55a6,6,0,0,0,2.7,4.69c1.5.86,2.72.17,2.72-1.56A5.94,5.94,0,0,0,411.25,183.45Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.3,109.81h0l1.26-.62h0Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.84,110h0l.46-.22h0Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "162.93 14.65 153.33 20.19 143.58 25.82 153.33 20.19 162.93 14.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.01 46.27 162.99 37.37 162.97 29.24 162.99 37.37 163.01 46.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.56,109.19l.27-.13-.27.13Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.13 85.3 163.1 77.85 163.09 71.34 163.1 77.85 163.13 85.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.12,111.56q1.84-.66,3.72-1.53h0Q166,110.9,164.12,111.56Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.43 42.12 134.51 70.71 134.56 87.28 134.51 70.71 134.43 42.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.79,120.76l0-6.51-.3.17-.54.32c-4.81,2.91-9.64,7.47-14.13,12.41-.75.81-1.48,1.64-2.21,2.47-3.79,4.34-7.49,8.94-11.31,13.24l0,10.52,4.59-2.65A101.06,101.06,0,0,1,182.79,120.76Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.84,136.91l0-8.7a55.19,55.19,0,0,0-9.76,14.35Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.05,142.56a55.19,55.19,0,0,1,9.76-14.35l0-7.45a101.06,101.06,0,0,0-23.89,30l14.15-8.17Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.84,110h0",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.3,109.81h0",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163.45,111.79l.67-.23q1.84-.66,3.72-1.53l.46-.22,1.26-.62c.73-.37,1.45-.76,2.18-1.17-.73.41-1.45.8-2.18,1.17l.27-.13c.63-.33,1.27-.68,1.91-1l.41-.23.34-.2a69.83,69.83,0,0,0,9.82-7l.42-.37,0-11c-7,3.57-13.85,4.68-19.39,3A17,17,0,0,1,154.12,85l.08,28.59A33.46,33.46,0,0,0,163.45,111.79Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.8,127.15c4.49-4.94,9.32-9.5,14.13-12.41l.54-.32.3-.17,0-6.3A136.44,136.44,0,0,0,157,127.53c-.93.89-1.86,1.79-2.79,2.66l0,12.67c3.82-4.3,7.52-8.9,11.31-13.24C166.32,128.79,167.05,128,167.8,127.15Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.75,108l0-7.76-.42.37a69.83,69.83,0,0,1-9.82,7l-.34.2-.41.23c-.64.36-1.28.71-1.91,1l-.27.13-.17.09h0l.17-.09-1.26.62-.46.22q-1.87.87-3.72,1.53l.7-.26-.7.26-.67.23a33.46,33.46,0,0,1-9.25,1.83l.05,16.57c.93-.87,1.86-1.77,2.79-2.66A136.44,136.44,0,0,1,182.75,108Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M182.68,80.29l0-8.14c-4.41-1-7.83-4.24-9.63-9.05l-9.75,5.63A20.15,20.15,0,0,0,182.68,80.29Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.31,92.15c5.54,1.72,12.41.61,19.39-3l0-8.9a20.15,20.15,0,0,1-19.41-11.56L154.09,74l0,11A17,17,0,0,0,163.31,92.15Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.21,54.79,152.47,73.12l.24,83,31.74-18.32Zm-29.9,98.59,0-10.52,0-12.67-.05-16.57L154.12,85l0-11,9.18-5.3L173,63.1l9.59-5.54,0,14.59,0,8.14,0,8.9,0,11,0,7.76,0,6.3,0,6.51,0,7.45,0,8.7-9.79,5.65h0l-14.15,8.17Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M169.36,109.29h0",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M169.39,109.28l.17-.09",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.74,108c-.73.41-1.45.8-2.18,1.17",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 149.88,
    y1: 66.27,
    x2: 149.88,
    y2: 66.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.12,111.56l.7-.26",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.65,72.15l0-14.59L173,63.1C174.82,67.91,178.24,71.12,182.65,72.15Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "164.76 94.91 133.02 113.24 133.03 115.44 166.67 96.02 164.76 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.53 11.88 164.76 94.91 166.67 96.02 166.43 10.78 164.53 11.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.22,44.86,147.33,70.19l.28,97,43.88-25.34Zm-38.51,113.5v-2.21l-.24-83,31.74-18.33,1.9-1.09.25,85.23Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "171.53 1.94 167.91 0 124.03 25.34 127.65 27.28 171.53 1.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.03 25.34 124.3 122.34 127.92 124.28 127.65 27.28 124.03 25.34"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.77,335.54l16.16.48,16.16-.48c.7,10.92-1.43,22-4.37,27.47h0a7.41,7.41,0,0,1-3.2,3.26C63.74,369,56,369,51.3,366.27a7.23,7.23,0,0,1-3.2-3.34C45.19,357.46,43.08,346.4,43.77,335.54Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.54,328.93c-6.33,3.65-6.36,9.58-.07,13.23s16.52,3.66,22.85,0,6.37-9.58.08-13.23S54.88,325.27,48.54,328.93Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.05,330.38c-4.94,2.85-5,7.48-.06,10.33s12.89,2.85,17.83,0,5-7.48.06-10.33S56,327.53,51.05,330.38Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.05,330.38c-4.94,2.85-5,7.48-.06,10.33s12.89,2.85,17.83,0,5-7.48.06-10.33S56,327.53,51.05,330.38Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33.36,266.59c36.42,11.92,36.75,36.28,28.54,53.63-2.07,3.52-8.34,5.4-13.79-16.18l9.57,1.23-11.15-5.65L43.63,291l9.3.69-11.8-5A175,175,0,0,0,33.36,266.59Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M33.36,266.59c36.42,11.92,36.75,36.28,28.54,53.63-2.07,3.52-8.34,5.4-13.79-16.18l9.57,1.23-11.15-5.65L43.63,291l9.3.69-11.8-5A175,175,0,0,0,33.36,266.59Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M33.36,266.59c36.42,11.92,36.75,36.28,28.54,53.63-2.07,3.52-8.34,5.4-13.79-16.18l9.57,1.23-11.15-5.65L43.63,291l9.3.69-11.8-5A175,175,0,0,0,33.36,266.59Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.66,272.68C62.87,287.26,64.6,304,59.18,321.41,61.1,306.05,63.17,290.52,43.66,272.68Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M95.05,291.34c-35.9,5.05-40.26,27.68-35.49,45.21,1.34,3.61,6.86,6.41,15.53-12.78L66,323.32l11.32-3.41,4.13-7.58-8.77-.9,11.81-2.66A163.56,163.56,0,0,1,95.05,291.34Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M95.05,291.34c-35.9,5.05-40.26,27.68-35.49,45.21,1.34,3.61,6.86,6.41,15.53-12.78L66,323.32l11.32-3.41,4.13-7.58-8.77-.9,11.81-2.66A163.56,163.56,0,0,1,95.05,291.34Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M95.05,291.34c-35.9,5.05-40.26,27.68-35.49,45.21,1.34,3.61,6.86,6.41,15.53-12.78L66,323.32l11.32-3.41,4.13-7.58-8.77-.9,11.81-2.66A163.56,163.56,0,0,1,95.05,291.34Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.44,295.3C64.13,305.68,59.74,321,61.9,338.11,62.66,323.48,63.31,308.67,84.44,295.3Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M22.86,299.82c32.92.54,39.38,20.45,37,36.77-.8,3.41-5.47,6.55-15.42-9.77l8.16-1.43-10.59-1.8-4.57-6.37,7.8-1.79-10.94-1.08A150.2,150.2,0,0,0,22.86,299.82Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.86,302.2C52.32,309.29,58,322.56,58,338.26,55.64,325.17,53.4,311.89,32.86,302.2Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M22.86,299.82c32.92.54,39.38,20.45,37,36.77-.8,3.41-5.47,6.55-15.42-9.77l8.16-1.43-10.59-1.8-4.57-6.37,7.8-1.79-10.94-1.08A150.2,150.2,0,0,0,22.86,299.82Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M434.77,306.94l16.94.5,17-.5c.73,11.45-1.5,23.11-4.58,28.81h0a7.72,7.72,0,0,1-3.35,3.41c-5,2.89-13.08,2.89-18,0a7.51,7.51,0,0,1-3.35-3.5C436.25,329.93,434,318.33,434.77,306.94Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M439.77,300c-6.64,3.84-6.68,10.05-.08,13.89s17.33,3.83,24,0,6.67-10.05.08-13.89S446.41,296.17,439.77,300Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.4,301.53c-5.18,3-5.21,7.84-.07,10.83s13.52,3,18.7,0,5.21-7.84.06-10.83S447.58,298.54,442.4,301.53Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.4,301.53c-5.18,3-5.21,7.84-.07,10.83s13.52,3,18.7,0,5.21-7.84.06-10.83S447.58,298.54,442.4,301.53Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M460.36,272.26c2.75-3.42,5.95-6.49,8.48-10.09,1.73-2.46,3.17-5.46,2.44-8.37a7.5,7.5,0,0,0-5.93-5.23,11.38,11.38,0,0,0-8,1.78,24.28,24.28,0,0,0-6,5.73,59.81,59.81,0,0,0-12.6,42.7,9,9,0,0,0,1.58,4.91,4.89,4.89,0,0,0,5.06,1.55c4.62-1.37,4-7.61,4.76-11.27a51.09,51.09,0,0,1,10.19-21.71Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M460.36,272.26c2.75-3.42,5.95-6.49,8.48-10.09,1.73-2.46,3.17-5.46,2.44-8.37a7.5,7.5,0,0,0-5.93-5.23,11.38,11.38,0,0,0-8,1.78,24.28,24.28,0,0,0-6,5.73,59.81,59.81,0,0,0-12.6,42.7,9,9,0,0,0,1.58,4.91,4.89,4.89,0,0,0,5.06,1.55c4.62-1.37,4-7.61,4.76-11.27a51.09,51.09,0,0,1,10.19-21.71Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.12,300.59a.41.41,0,0,0,.33-.38c.32-7.41,2.73-32.7,20.16-47a.4.4,0,0,0,.06-.57.41.41,0,0,0-.57-.06c-17.69,14.57-20.13,40.15-20.46,47.65a.41.41,0,0,0,.39.42Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M442.58,301.4a12.34,12.34,0,0,0,5.66,7.84,15.91,15.91,0,0,0,8.56,1.44,37.87,37.87,0,0,0,8.7-2.06c1.39-.47,2.95-1.11,3.1-2.84a3.08,3.08,0,0,0-1-2.44,11.45,11.45,0,0,0-.9-.78.89.89,0,0,1,.47-1.6,20.74,20.74,0,0,0,2.48-.31,10.89,10.89,0,0,0,5.2-2.35,8.71,8.71,0,0,0,2.41-3.56c.42-1.16.54-2.62-.35-3.49a3.76,3.76,0,0,0-1.92-.84c-.62-.13-1.24-.25-1.87-.35a.83.83,0,0,1-.19-1.58l2.63-1.09a4.94,4.94,0,0,0,2-1.24,4.33,4.33,0,0,0,.51-3.62c-.32-1.65-.89-3.23-1.28-4.87a10.46,10.46,0,0,1-.17-5,41.73,41.73,0,0,0-14.73,1,10.6,10.6,0,0,0-4,1.76c-1.64,1.31-2.06,3.28-1.89,5.41a.38.38,0,0,1-.71.2L453.59,278a2,2,0,0,0-2.62-.84,12.1,12.1,0,0,0-3.84,3,6.66,6.66,0,0,0-1.64,4.92,43,43,0,0,0,1.22,7.22.66.66,0,0,1-1,.7l-.08-.05a2.23,2.23,0,0,0-1.59-.46c-1.48.18-1.86,1.68-2,3A25,25,0,0,0,442.58,301.4Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M442.58,301.4a12.34,12.34,0,0,0,5.66,7.84,15.91,15.91,0,0,0,8.56,1.44,37.87,37.87,0,0,0,8.7-2.06c1.39-.47,2.95-1.11,3.1-2.84a3.08,3.08,0,0,0-1-2.44,11.45,11.45,0,0,0-.9-.78.89.89,0,0,1,.47-1.6,20.74,20.74,0,0,0,2.48-.31,10.89,10.89,0,0,0,5.2-2.35,8.71,8.71,0,0,0,2.41-3.56c.42-1.16.54-2.62-.35-3.49a3.76,3.76,0,0,0-1.92-.84c-.62-.13-1.24-.25-1.87-.35a.83.83,0,0,1-.19-1.58l2.63-1.09a4.94,4.94,0,0,0,2-1.24,4.33,4.33,0,0,0,.51-3.62c-.32-1.65-.89-3.23-1.28-4.87a10.46,10.46,0,0,1-.17-5,41.73,41.73,0,0,0-14.73,1,10.6,10.6,0,0,0-4,1.76c-1.64,1.31-2.06,3.28-1.89,5.41a.38.38,0,0,1-.71.2L453.59,278a2,2,0,0,0-2.62-.84,12.1,12.1,0,0,0-3.84,3,6.66,6.66,0,0,0-1.64,4.92,43,43,0,0,0,1.22,7.22.66.66,0,0,1-1,.7l-.08-.05a2.23,2.23,0,0,0-1.59-.46c-1.48.18-1.86,1.68-2,3A25,25,0,0,0,442.58,301.4Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M442.58,301.4a12.34,12.34,0,0,0,5.66,7.84,15.91,15.91,0,0,0,8.56,1.44,37.87,37.87,0,0,0,8.7-2.06c1.39-.47,2.95-1.11,3.1-2.84a3.08,3.08,0,0,0-1-2.44,11.45,11.45,0,0,0-.9-.78.89.89,0,0,1,.47-1.6,20.74,20.74,0,0,0,2.48-.31,10.89,10.89,0,0,0,5.2-2.35,8.71,8.71,0,0,0,2.41-3.56c.42-1.16.54-2.62-.35-3.49a3.76,3.76,0,0,0-1.92-.84c-.62-.13-1.24-.25-1.87-.35a.83.83,0,0,1-.19-1.58l2.63-1.09a4.94,4.94,0,0,0,2-1.24,4.33,4.33,0,0,0,.51-3.62c-.32-1.65-.89-3.23-1.28-4.87a10.46,10.46,0,0,1-.17-5,41.73,41.73,0,0,0-14.73,1,10.6,10.6,0,0,0-4,1.76c-1.64,1.31-2.06,3.28-1.89,5.41a.38.38,0,0,1-.71.2L453.59,278a2,2,0,0,0-2.62-.84,12.1,12.1,0,0,0-3.84,3,6.66,6.66,0,0,0-1.64,4.92,43,43,0,0,0,1.22,7.22.66.66,0,0,1-1,.7l-.08-.05a2.23,2.23,0,0,0-1.59-.46c-1.48.18-1.86,1.68-2,3A25,25,0,0,0,442.58,301.4Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M450.39,308.84a59.13,59.13,0,0,1,4-11.48.41.41,0,0,1,.14-.3l.27-.6a37.11,37.11,0,0,0-3.92-13.14.41.41,0,1,1,.7-.41,37.65,37.65,0,0,1,3.87,12.22c3.35-6.72,8.7-14.59,17-20.33a.39.39,0,0,1,.56.1.4.4,0,0,1-.1.56c-8.52,5.93-13.89,14.14-17.16,21a24.73,24.73,0,0,1,14-1.9.4.4,0,0,1,.32.47.39.39,0,0,1-.32.32h-.15c-.08,0-7.79-1.41-14.45,2.31A58.86,58.86,0,0,0,451.18,309a.39.39,0,0,1-.32.31h-.16A.39.39,0,0,1,450.39,308.84Z",
    transform: "translate(-19.69 -42.91)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "48.86 179.24 48.82 164.97 41.38 160.73 41.42 174.67 41.42 174.67 41.42 174.99 48.86 179.24 48.86 179.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M69,387.38l-.47-165.23-7.44-4.25.46,164.92a3.13,3.13,0,0,0,1.25,2.79h0l0,0,0,0,7.34,4.48A3.09,3.09,0,0,1,69,387.38Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M69,387.38l-.47-165.23-7.44-4.25.46,164.92a3.13,3.13,0,0,0,1.25,2.79h0l0,0,0,0,7.34,4.48A3.09,3.09,0,0,1,69,387.38Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M73.44,389.9a5.45,5.45,0,0,1-.86.4A5.45,5.45,0,0,0,73.44,389.9Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M72,390.44l-.18,0Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M70.45,390.28h0l0,0Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.54,207.85l0-8.21A9.71,9.71,0,0,1,72.9,192l249-143.75a3.15,3.15,0,0,1,3.08-.33l-7.35-4.51h0a3.06,3.06,0,0,0-3.18.26l-249,143.75a9.68,9.68,0,0,0-4.39,7.62l0,8.22h0l0,0v.32l7.44,4.24Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M68.54,207.85l0-8.21A9.71,9.71,0,0,1,72.9,192l249-143.75a3.15,3.15,0,0,1,3.08-.33l-7.35-4.51h0a3.06,3.06,0,0,0-3.18.26l-249,143.75a9.68,9.68,0,0,0-4.39,7.62l0,8.22h0l0,0v.32l7.44,4.24Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.86 179.24 48.82 164.97 41.38 160.73 41.42 174.67 41.42 174.67 41.42 174.99 48.86 179.24 48.86 179.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "48.86 179.24 48.82 164.97 41.38 160.73 41.42 174.67 41.42 174.67 41.42 174.99 48.86 179.24 48.86 179.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M321.89,48.27c2.43-1.4,4.41-.27,4.42,2.53l0,8.22L68.54,207.85l0-8.21A9.71,9.71,0,0,1,72.9,192Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M305.2,61.87c1.3-.76,2.36-.15,2.36,1.34a5.16,5.16,0,0,1-2.35,4.07c-1.3.76-2.36.15-2.36-1.34A5.13,5.13,0,0,1,305.2,61.87Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M312.39,57.71c1.3-.75,2.36-.14,2.36,1.35a5.13,5.13,0,0,1-2.35,4.07c-1.3.75-2.36.15-2.36-1.35A5.19,5.19,0,0,1,312.39,57.71Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M319.57,53.57c1.31-.76,2.36-.15,2.37,1.34A5.19,5.19,0,0,1,319.59,59c-1.3.76-2.36.15-2.37-1.34A5.19,5.19,0,0,1,319.57,53.57Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.38,169.77c1-.56,1.87-.46,2.33.26l2.34,3.6c.47.72,1.36.82,2.33.26L326.3,59l0,14.29L68.55,222.17l0-14.29,7.64-4.41a5.89,5.89,0,0,0,2.33-2.95l2.3-6.28a5.79,5.79,0,0,1,2.32-2.94Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M326.34,73.31l.47,165.24a9.67,9.67,0,0,1-4.39,7.6L73.44,389.9c-2.44,1.41-4.41.28-4.42-2.52l-.47-165.23Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326.34,73.31l.47,165.24a9.67,9.67,0,0,1-4.39,7.6L73.44,389.9c-2.44,1.41-4.41.28-4.42-2.52l-.47-165.23Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M316.15,67.82c1.73-1,3.13-.2,3.14,1.79A6.9,6.9,0,0,1,316.17,75L98,201c-1.73,1-3.14.19-3.15-1.8a6.9,6.9,0,0,1,3.13-5.4Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.67,209.15a.31.31,0,0,1,.33,0c.16.11.15.44,0,.73l-1.37,2.25L75.21,210a.27.27,0,0,1,.44.25.94.94,0,0,1-.44.77l-3.61,2.08,1.38.66c.18.09.2.4,0,.69a1,1,0,0,1-.32.36.35.35,0,0,1-.31,0l-2.21-1.06-.09-.09v0l0-.18,0-.22,0,0,.08-.18,2.21-3.62A.81.81,0,0,1,72.67,209.15Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.49,204.64a.33.33,0,0,1,.3,0L83,205.65l.08.1h0l0,.18,0,.22,0,.05-.07.18L80.81,210a.86.86,0,0,1-.3.3.29.29,0,0,1-.32,0c-.17-.1-.16-.43,0-.73l1.37-2.24L78,209.45c-.24.13-.44,0-.44-.26a1,1,0,0,1,.43-.76l3.62-2.08-1.38-.66c-.19-.09-.19-.4,0-.71A.88.88,0,0,1,80.49,204.64Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.91,200.35a2,2,0,0,1,1.5-.28l.33-.44a.83.83,0,0,1,.24-.22.42.42,0,0,1,.24,0c.15,0,.22.18.2.4l-.19,1.36a1,1,0,0,1-.19.45.82.82,0,0,1-.24.22l-.11.05-1.07.3a.25.25,0,0,1-.33-.23.85.85,0,0,1,.2-.61l.1-.14a1.39,1.39,0,0,0-.67.2,3.51,3.51,0,0,0-1.59,2.74c0,1,.72,1.42,1.6.91a3.42,3.42,0,0,0,1.39-1.74,1,1,0,0,1,.38-.49.45.45,0,0,1,.21-.06c.22,0,.3.28.18.59A5.43,5.43,0,0,1,87.93,206c-1.36.78-2.47.15-2.48-1.42A5.44,5.44,0,0,1,87.91,200.35Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.67,209.15a.31.31,0,0,1,.33,0c.16.11.15.44,0,.73l-1.37,2.25L75.21,210a.27.27,0,0,1,.44.25.94.94,0,0,1-.44.77l-3.61,2.08,1.38.66c.18.09.2.4,0,.69a1,1,0,0,1-.32.36.35.35,0,0,1-.31,0l-2.21-1.06-.09-.09v0l0-.18,0-.22,0,0,.08-.18,2.21-3.62A.81.81,0,0,1,72.67,209.15Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.49,204.64a.33.33,0,0,1,.3,0L83,205.65l.08.1h0l0,.18,0,.22,0,.05-.07.18L80.81,210a.86.86,0,0,1-.3.3.29.29,0,0,1-.32,0c-.17-.1-.16-.43,0-.73l1.37-2.24L78,209.45c-.24.13-.44,0-.44-.26a1,1,0,0,1,.43-.76l3.62-2.08-1.38-.66c-.19-.09-.19-.4,0-.71A.88.88,0,0,1,80.49,204.64Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.91,200.35a2,2,0,0,1,1.5-.28l.33-.44a.83.83,0,0,1,.24-.22.42.42,0,0,1,.24,0c.15,0,.22.18.2.4l-.19,1.36a1,1,0,0,1-.19.45.82.82,0,0,1-.24.22l-.11.05-1.07.3a.25.25,0,0,1-.33-.23.85.85,0,0,1,.2-.61l.1-.14a1.39,1.39,0,0,0-.67.2,3.51,3.51,0,0,0-1.59,2.74c0,1,.72,1.42,1.6.91a3.42,3.42,0,0,0,1.39-1.74,1,1,0,0,1,.38-.49.45.45,0,0,1,.21-.06c.22,0,.3.28.18.59A5.43,5.43,0,0,1,87.93,206c-1.36.78-2.47.15-2.48-1.42A5.44,5.44,0,0,1,87.91,200.35Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.9,121.62l.23,59.41a15.34,15.34,0,0,1-7.63,13.29L178.79,269a5.1,5.1,0,0,1-7.66-4.4l-.22-59.41a15.31,15.31,0,0,1,7.62-13.29l128.71-74.66A5.1,5.1,0,0,1,314.9,121.62Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "243.02 114.68 217.19 163.74 209.88 177.63 214.92 161.99 200.68 150.93 184.81 182.43 184.87 201.68 268.1 153.63 268.05 134.38 243.02 114.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M235.42,183.6a15.63,15.63,0,0,0,7.07-12.25c0-4.5-3.2-6.32-7.12-4.06a15.6,15.6,0,0,0-7.07,12.25C228.31,184,231.5,185.86,235.42,183.6Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "243.02 114.68 217.19 163.74 209.88 177.63 214.92 161.99 200.68 150.93 184.81 182.43 184.87 201.68 268.1 153.63 268.05 134.38 243.02 114.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M235.42,183.6a15.63,15.63,0,0,0,7.07-12.25c0-4.5-3.2-6.32-7.12-4.06a15.6,15.6,0,0,0-7.07,12.25C228.31,184,231.5,185.86,235.42,183.6Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M239,245.61l.1,35.88a6.94,6.94,0,0,1-3.45,6L174.47,323a2.31,2.31,0,0,1-3.46-2l-.1-35.89a6.89,6.89,0,0,1,3.45-6l61.16-35.49A2.31,2.31,0,0,1,239,245.61Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "179.25 232.76 198.19 234.38 179.32 257.85 179.25 232.76"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "179.25 232.76 198.19 234.38 179.32 257.85 179.25 232.76"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.2,202l.1,35.88a6.91,6.91,0,0,1-3.45,6L250,278.75a2.31,2.31,0,0,1-3.47-2l-.1-35.88a6.94,6.94,0,0,1,3.45-6L310.73,200A2.31,2.31,0,0,1,314.2,202Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "253.82 187.85 272.77 189.47 253.9 212.94 253.82 187.85"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "253.82 187.85 272.77 189.47 253.9 212.94 253.82 187.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "116.74 156.44 116.77 165.49 65 195.38 64.97 186.33 116.74 156.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "95.97 182.44 95.98 186.94 65.02 204.81 65.01 200.31 95.97 182.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "179.77 120.1 179.78 125.38 164.79 134.03 164.78 128.75 179.77 120.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "208.51 103.5 208.53 108.78 188.54 120.32 188.53 115.04 208.51 103.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "266.3 70.14 266.32 75.41 251.32 84.07 251.31 78.79 266.3 70.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "295.05 53.54 295.07 58.81 275.08 70.36 275.06 65.08 295.05 53.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "241.02 84.73 241.04 90.01 217.18 103.78 217.17 98.5 241.02 84.73"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "117.14 207.28 117.15 211.26 65.08 241.32 65.07 237.34 117.14 207.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "85.54 232.45 85.55 236.44 65.1 248.25 65.09 244.26 85.54 232.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "117.21 230.65 117.22 234.64 65.15 264.7 65.14 260.71 117.21 230.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "117.19 223.73 117.2 227.72 65.13 257.78 65.12 253.79 117.19 223.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "117.12 200.35 117.13 204.34 65.06 234.4 65.05 230.41 117.12 200.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "105.98 244.06 106 248.05 65.17 271.62 65.16 267.63 105.98 244.06"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.3,312c4.48-2.59,8.13-.51,8.15,4.64s-3.61,11.43-8.1,14L91.77,355.81c-4.49,2.59-8.14.52-8.15-4.64s3.61-11.43,8.09-14Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "87.52 291.11 87.56 298.08 85.69 299.16 85.67 295.99 84.35 299.31 83.45 299.83 82.12 298.15 82.13 301.22 80.27 302.3 80.25 295.31 81.93 294.34 83.92 296.92 85.84 292.08 87.52 291.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.41,331.44c2-1.14,3.43-.44,3.44,1.67a7,7,0,0,1-3.42,5.64c-2,1.14-3.44.44-3.45-1.67A7,7,0,0,1,111.41,331.44Zm0,5.4a3,3,0,0,0,1.36-2.53c0-1.09-.61-1.4-1.37-1a3,3,0,0,0-1.35,2.53c0,1.09.61,1.39,1.36,1",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.15,331.39l1.29,1.41-2.19,1.27-1-1.16-.56.32V335l-2,1.18,0-7,2.93-1.7c1.69-1,2.77-.58,2.78,1A4.43,4.43,0,0,1,120.15,331.39Zm-1.76-.37a1.46,1.46,0,0,0,.83-1.29c0-.51-.27-.67-.83-.34l-.75.43v1.63l.74-.43",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "107.32 279.68 107.32 281.46 104.4 283.15 104.4 283.97 106.97 282.49 106.97 284.18 104.4 285.66 104.41 286.58 107.44 284.83 107.45 286.6 102.4 289.52 102.38 282.53 107.32 279.68"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Datas"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "233.57 384 233.56 388.38 203.82 371.21 203.84 366.84 233.57 384"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "233.59 377.4 233.58 381.79 221.48 374.81 221.5 370.42 233.59 377.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "184.29 362.15 184.28 366.52 162.87 354.16 162.88 349.79 184.29 362.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.22 363.01 197.2 367.39 162.88 347.57 162.9 343.2 197.22 363.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "215.73 367.09 215.72 371.48 181.76 351.87 178.45 349.96 162.68 340.85 162.69 336.47 178.46 345.57 181.77 347.48 215.73 367.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "205.84 345.79 205.82 350.16 162.95 325.41 162.96 321.03 205.84 345.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "203.37 337.75 203.36 342.13 194.98 337.29 194.99 332.92 203.37 337.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "200.94 371.76 200.92 376.14 188.84 369.16 188.85 364.78 200.94 371.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "233.66 355.24 233.64 359.61 209.8 345.84 209.81 341.47 233.66 355.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "233.67 348.65 233.66 353.02 216.99 343.4 213.32 341.27 191.22 328.52 191.23 324.14 213.33 336.9 217.01 339.02 233.67 348.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "215.85 325.14 215.84 329.52 188.09 313.5 188.1 309.12 215.85 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "188.04 328.9 188.03 333.28 162.97 318.81 162.98 314.43 188.04 328.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "184.41 320.2 184.39 324.58 162.99 312.22 163 307.84 184.41 320.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "181.89 305.54 181.88 309.91 162.79 298.89 162.81 294.52 181.89 305.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.34 321.07 197.32 325.44 163 305.63 163.02 301.25 197.34 321.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "191.02 304.21 191.01 308.58 162.81 292.3 162.82 287.93 191.02 304.21"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "233.69 342.06 233.68 346.43 203.94 329.26 203.96 324.89 233.69 342.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "233.71 335.46 233.7 339.83 221.6 332.85 221.62 328.47 233.71 335.46"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.57 384 233.56 388.38 203.82 371.21 203.84 366.84 233.57 384"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.59 377.4 233.58 381.79 221.48 374.81 221.5 370.42 233.59 377.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "184.29 362.15 184.28 366.52 162.87 354.16 162.88 349.79 184.29 362.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "197.22 363.01 197.2 367.39 162.88 347.57 162.9 343.2 197.22 363.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "215.73 367.09 215.72 371.48 181.76 351.87 178.45 349.96 162.68 340.85 162.69 336.47 178.46 345.57 181.77 347.48 215.73 367.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "205.84 345.79 205.82 350.16 162.95 325.41 162.96 321.03 205.84 345.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "203.37 337.75 203.36 342.13 194.98 337.29 194.99 332.92 203.37 337.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "200.94 371.76 200.92 376.14 188.84 369.16 188.85 364.78 200.94 371.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.66 355.24 233.64 359.61 209.8 345.84 209.81 341.47 233.66 355.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.67 348.65 233.66 353.02 216.99 343.4 213.32 341.27 191.22 328.52 191.23 324.14 213.33 336.9 217.01 339.02 233.67 348.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "215.85 325.14 215.84 329.52 188.09 313.5 188.1 309.12 215.85 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "188.04 328.9 188.03 333.28 162.97 318.81 162.98 314.43 188.04 328.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "184.41 320.2 184.39 324.58 162.99 312.22 163 307.84 184.41 320.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "181.89 305.54 181.88 309.91 162.79 298.89 162.81 294.52 181.89 305.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "197.34 321.07 197.32 325.44 163 305.63 163.02 301.25 197.34 321.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "191.02 304.21 191.01 308.58 162.81 292.3 162.82 287.93 191.02 304.21"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.69 342.06 233.68 346.43 203.94 329.26 203.96 324.89 233.69 342.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.71 335.46 233.7 339.83 221.6 332.85 221.62 328.47 233.71 335.46"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M168,341.76l-10.14-6a.51.51,0,0,1-.25-.44V272.12l-13.08-7.57.51-.88,13.33,7.72a.51.51,0,0,1,.26.44v63.23l9.89,5.82Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M170.92,338.7a8,8,0,0,1,3.61,6.26c0,2.3-1.63,3.23-3.64,2.07a8,8,0,0,1-3.61-6.26C167.29,338.47,168.92,337.54,170.92,338.7Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M146.67,261a8,8,0,0,1,3.62,6.26c0,2.3-1.64,3.23-3.64,2.07a8,8,0,0,1-3.62-6.26C143,260.78,144.67,259.85,146.67,261Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M168,341.76l-10.14-6a.51.51,0,0,1-.25-.44V272.12l-13.08-7.57.51-.88,13.33,7.72a.51.51,0,0,1,.26.44v63.23l9.89,5.82Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M170.92,338.7a8,8,0,0,1,3.61,6.26c0,2.3-1.63,3.23-3.64,2.07a8,8,0,0,1-3.61-6.26C167.29,338.47,168.92,337.54,170.92,338.7Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.67,261a8,8,0,0,1,3.62,6.26c0,2.3-1.64,3.23-3.64,2.07a8,8,0,0,1-3.62-6.26C143,260.78,144.67,259.85,146.67,261Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "410.43 88.69 410.42 93.06 380.68 75.89 380.69 71.52 410.43 88.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "410.45 82.09 410.44 86.47 398.34 79.49 398.35 75.1 410.45 82.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "361.14 66.83 361.13 71.21 339.72 58.85 339.73 54.47 361.14 66.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "374.07 67.7 374.06 72.07 339.74 52.26 339.75 47.88 374.07 67.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "392.59 71.78 392.57 76.16 358.61 56.55 355.3 54.64 339.53 45.54 339.54 41.15 355.32 50.26 358.63 52.17 392.59 71.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "377.79 76.45 377.78 80.82 365.69 73.84 365.7 69.47 377.79 76.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "410.43 88.69 410.42 93.06 380.68 75.89 380.69 71.52 410.43 88.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "410.45 82.09 410.44 86.47 398.34 79.49 398.35 75.1 410.45 82.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "361.14 66.83 361.13 71.21 339.72 58.85 339.73 54.47 361.14 66.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "374.07 67.7 374.06 72.07 339.74 52.26 339.75 47.88 374.07 67.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "392.59 71.78 392.57 76.16 358.61 56.55 355.3 54.64 339.53 45.54 339.54 41.15 355.32 50.26 358.63 52.17 392.59 71.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "377.79 76.45 377.78 80.82 365.69 73.84 365.7 69.47 377.79 76.45"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "410.45 105.74 410.44 110.12 398.34 103.14 398.35 98.75 410.45 105.74"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "374.07 91.35 374.06 95.72 339.74 75.91 339.75 71.53 374.07 91.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "392.59 95.42 392.57 99.81 358.61 80.2 355.3 78.29 339.53 69.19 339.54 64.8 355.32 73.91 358.63 75.82 392.59 95.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "410.45 105.74 410.44 110.12 398.34 103.14 398.35 98.75 410.45 105.74"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "374.07 91.35 374.06 95.72 339.74 75.91 339.75 71.53 374.07 91.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "392.59 95.42 392.57 99.81 358.61 80.2 355.3 78.29 339.53 69.19 339.54 64.8 355.32 73.91 358.63 75.82 392.59 95.42"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.28,135c-2-1.16-3.63-.23-3.63,2.07a7.1,7.1,0,0,0,.86,3.19l-51,29.52-16.08-9.38a8,8,0,0,0-3.61-6.2c-2-1.16-3.63-.23-3.64,2.07a8,8,0,0,0,3.61,6.26c1.67,1,3.06.47,3.49-1l16.23,9.47L375,141.09a7,7,0,0,0,2.23,2.2c2,1.16,3.63.23,3.64-2.07A8,8,0,0,0,377.28,135Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M377.28,135c-2-1.16-3.63-.23-3.63,2.07a7.1,7.1,0,0,0,.86,3.19l-51,29.52-16.08-9.38a8,8,0,0,0-3.61-6.2c-2-1.16-3.63-.23-3.64,2.07a8,8,0,0,0,3.61,6.26c1.67,1,3.06.47,3.49-1l16.23,9.47L375,141.09a7,7,0,0,0,2.23,2.2c2,1.16,3.63.23,3.64-2.07A8,8,0,0,0,377.28,135Z",
    transform: "translate(-19.69 -42.91)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M318.75,290.32c-8.52,5.92-18.12,10-25.23,17.95-13.3,14.81-13.61,38.66-3.17,55.6S320.21,391,340,393.34c20.74,2.44,42.5-3.29,58.78-16.38s26.62-33.55,26.61-54.43-10.7-41.68-28.19-53.09c-16-10.41-38.9-13.38-54.91-1.47-8.1,6-13.49,14.91-21.57,20.95C320.06,289.4,319.41,289.86,318.75,290.32Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M318.75,290.32c-8.52,5.92-18.12,10-25.23,17.95-13.3,14.81-13.61,38.66-3.17,55.6S320.21,391,340,393.34c20.74,2.44,42.5-3.29,58.78-16.38s26.62-33.55,26.61-54.43-10.7-41.68-28.19-53.09c-16-10.41-38.9-13.38-54.91-1.47-8.1,6-13.49,14.91-21.57,20.95C320.06,289.4,319.41,289.86,318.75,290.32Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M318.75,290.32c-8.52,5.92-18.12,10-25.23,17.95-13.3,14.81-13.61,38.66-3.17,55.6S320.21,391,340,393.34c20.74,2.44,42.5-3.29,58.78-16.38s26.62-33.55,26.61-54.43-10.7-41.68-28.19-53.09c-16-10.41-38.9-13.38-54.91-1.47-8.1,6-13.49,14.91-21.57,20.95C320.06,289.4,319.41,289.86,318.75,290.32Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M322.22,377.14l.06-.42A22.43,22.43,0,0,1,340.46,358a70.71,70.71,0,0,0,23.28-8.92c5.09-3.07,9.89-6.84,15.6-8.51a25.4,25.4,0,0,1,16.81,1c-4.79-5-13-7.26-19.59-5,4.55-7,8.55-14.46,10.12-22.63s.46-17.13-4.47-23.83a24,24,0,0,0-37-2c-4.88,5.34-7.63,12.84-10.83,19.32-2.31,4.66-4.68,9.42-8.48,13-5.72,5.35-13.95,7.28-19.88,12.4-6.73,5.81-9.63,15.09-9.66,24a70.76,70.76,0,0,0,2.6,17.73,67.33,67.33,0,0,0,24.33,14.87A26.42,26.42,0,0,1,322.22,377.14Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M414.24,319.66a61,61,0,0,0-52-59.18,44.82,44.82,0,0,0-5.88,1,59.42,59.42,0,0,1,56.27,58.22c.38,19.44-9.12,39.25-25.43,53-12.78,10.78-29.76,17.92-48.42,20.49l1.2.16c1.67.19,3.36.33,5,.42,16.57-3.21,31.59-10.05,43.2-19.84C404.91,359.86,414.63,339.58,414.24,319.66Z",
    transform: "translate(-19.69 -42.91)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M300.5,370.65a59.33,59.33,0,0,1,1,9.7l2.3-.87a5.94,5.94,0,0,1,6.39,1.45l.12.12a2.31,2.31,0,0,0,3.19.15h0a2.32,2.32,0,0,0,.8-1.67l.31-9.8Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.38,407c-4.77,5.11-13.56,9.58-19.95,5.22l.71,1.63c6.39,4.35,15.18-.11,20-5.22s1.68-8.65,6-13.18a15.51,15.51,0,0,0,3.72-5.52c-.19-.48-.38-1.12-.6-1.85a19.76,19.76,0,0,1-3.83,5.75C311.06,398.4,314.16,401.94,309.38,407Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M316.84,382.78a9.48,9.48,0,0,1-1.51-3.48,2,2,0,0,0-.94-1.42l-.05,1.65a2.32,2.32,0,0,1-4,1.52l-.12-.12a5.94,5.94,0,0,0-6.39-1.45l-2.34.88a1.8,1.8,0,0,0-1.16,1.72c.15,6.7-3,15.59-6.26,20.48-3.37,1.4-6.29,6-4.8,9.36l.15.34c6.39,4.36,15.18-.11,19.95-5.22s1.68-8.64,6-13.17a19.76,19.76,0,0,0,3.83-5.75A21.3,21.3,0,0,0,316.84,382.78Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.49,392.45a.82.82,0,0,0,1.09-.36.8.8,0,0,0-.33-1.08,9.34,9.34,0,0,0-9.18,0c-.14.53-.29,1.05-.45,1.57A9,9,0,0,1,307.49,392.45Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.67,388.83a.82.82,0,0,0,.75-1.45,9.81,9.81,0,0,0-9.54.08c-.1.55-.21,1.09-.33,1.64C302.33,387.63,305.14,387.05,308.67,388.83Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M306.2,396.06a.82.82,0,0,0,1.09-.37.81.81,0,0,0-.34-1.08,9.29,9.29,0,0,0-9-.09c-.2.57-.42,1.12-.64,1.67A9,9,0,0,1,306.2,396.06Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.08,402.56c-3.37,1.4-6.29,6-4.8,9.36l.15.34c6.29,4.29,14.91,0,19.73-5C305.14,399.39,296.74,401.35,294.08,402.56Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M304.79,399.58a.82.82,0,0,0,.75-1.45,9.29,9.29,0,0,0-9-.08c-.29.62-.58,1.22-.88,1.8C298.45,398.38,301.26,397.79,304.79,399.58Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M290.46,390.12a59.55,59.55,0,0,1-3,9.29l2.45.14a6,6,0,0,1,5.27,3.91l0,.15a2.33,2.33,0,0,0,2.87,1.43h0a2.36,2.36,0,0,0,1.4-1.21l4.23-8.84Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.9,427c-6.43,2.75-16.28,3.29-20.36-3.28v1.78c4.08,6.56,13.93,6,20.36,3.28s5-7.23,10.78-9.64a15.63,15.63,0,0,0,5.63-3.55c0-.53.11-1.18.2-1.94a19.41,19.41,0,0,1-5.83,3.71C288.92,419.77,290.33,424.26,283.9,427Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M300.51,407.82a9.32,9.32,0,0,1,0-3.8,2,2,0,0,0-.29-1.68l-.71,1.49a2.36,2.36,0,0,1-1.4,1.21,2.33,2.33,0,0,1-2.87-1.43l0-.15a6,6,0,0,0-5.27-3.91l-2.49-.14a1.8,1.8,0,0,0-1.76,1.1c-2.57,6.19-9,13.07-14,16.22-3.65-.09-8.17,2.94-8.17,6.63v.36c4.08,6.57,13.93,6,20.36,3.28s5-7.23,10.78-9.64a19.41,19.41,0,0,0,5.83-3.71A20.85,20.85,0,0,0,300.51,407.82Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M288.06,412.89a.81.81,0,0,0,1.27-1,9.33,9.33,0,0,0-8.4-3.69q-.51.65-1.05,1.26A9,9,0,0,1,288.06,412.89Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.6,410.05a.81.81,0,0,0,1.14.11.82.82,0,0,0,.13-1.13,9.79,9.79,0,0,0-8.76-3.78c-.31.46-.64.92-1,1.37C285.28,406.4,288.09,407,290.6,410.05Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M285.43,415.67a.81.81,0,0,0,1.27-1,9.32,9.32,0,0,0-8.18-3.71c-.41.44-.83.86-1.26,1.27A9,9,0,0,1,285.43,415.67Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M271.71,416.73c-3.65-.09-8.17,2.94-8.17,6.63v.36c4,6.47,13.63,6,20.06,3.4C283.11,418.29,274.63,416.69,271.71,416.73Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M282.71,418.32a.82.82,0,0,0,1.14.1.8.8,0,0,0,.13-1.12,9.3,9.3,0,0,0-8.19-3.71c-.51.46-1,.89-1.53,1.29C277.4,414.66,280.2,415.26,282.71,418.32Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M328.24,306.48l-32.19,17.93a16,16,0,0,0-7.92,16.84l6.25,33.65-5.12,16.27c4.42,5.93,14.56,6.23,14.56,6.23,5.66-11.35,9.82-16.17,13-25.68s5.36-16.08,5.36-16.08l26.73-7.3a31.67,31.67,0,0,0,23.16-26.95c.46-4.05.48-6.81.48-6.81Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M328.24,306.48l-32.19,17.93a16,16,0,0,0-7.92,16.84l6.25,33.65-5.12,16.27c4.42,5.93,14.56,6.23,14.56,6.23,5.66-11.35,9.82-16.17,13-25.68s5.36-16.08,5.36-16.08l26.73-7.3a31.67,31.67,0,0,0,23.16-26.95c.46-4.05.48-6.81.48-6.81Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M328.24,306.48l-32.19,17.93a16,16,0,0,0-7.92,16.84l6.25,33.65-5.12,16.27c4.42,5.93,14.56,6.23,14.56,6.23,5.66-11.35,9.82-16.17,13-25.68s5.36-16.08,5.36-16.08l26.73-7.3a31.67,31.67,0,0,0,23.16-26.95c.46-4.05.48-6.81.48-6.81Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M328.48,315.52a15.19,15.19,0,0,0,3.6,9.81l-22.71,14.22a16.31,16.31,0,0,0-6.95,9.06l-8,26.29,7.25-29.28a13.28,13.28,0,0,1,5.91-8.1l21-13C326.36,319.2,328.48,315.52,328.48,315.52Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M306.94,269.52l-7.24,6.54c-4.63-5.91-10.84-9.9-16.27-18.18-1.56-2-1.4-5.93-2.46-7.95-.84-1.58-2.3-4-2.91-5.29a.88.88,0,0,0-1.33-.35c-1.49,1.14-.68,3.8.12,6.59.95,3.3-4-1.17-4.7-1.93-3.16-2.94-5.87-10.15-8-9.43s-.45,4.31-.45,4.31c-2,.42-1.23,3.58-1.23,3.58-1.17,2.07-.84,5.26,1.57,8.23,1.75,2.15,6.48,5.11,8.94,6.56a8.1,8.1,0,0,1,2.56,2.42L291,287.68a9.29,9.29,0,0,0,13.26,2.25l10.53-7.88Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M306.94,269.52l-7.24,6.54c-4.63-5.91-10.84-9.9-16.27-18.18-1.56-2-1.4-5.93-2.46-7.95-.84-1.58-2.3-4-2.91-5.29a.88.88,0,0,0-1.33-.35c-1.49,1.14-.68,3.8.12,6.59.95,3.3-4-1.17-4.7-1.93-3.16-2.94-5.87-10.15-8-9.43s-.45,4.31-.45,4.31c-2,.42-1.23,3.58-1.23,3.58-1.17,2.07-.84,5.26,1.57,8.23,1.75,2.15,6.48,5.11,8.94,6.56a8.1,8.1,0,0,1,2.56,2.42L291,287.68a9.29,9.29,0,0,0,13.26,2.25l10.53-7.88Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M330.37,251.41c-7.86-.34-18.29,11.32-25,18.31a25.76,25.76,0,0,0,8.78,14.07A190.52,190.52,0,0,0,330.37,271Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.37,251.41c-7.86-.34-18.29,11.32-25,18.31a25.76,25.76,0,0,0,8.78,14.07A190.52,190.52,0,0,0,330.37,271Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M373.09,317.09c-5.71,5.49-33.13,6.5-47.12-6.82,1.34-9.41.89-19.48,0-29.44s-6.72-27.39,4.4-29.42c14.85-2.9,24.55-2.67,34.48,2.92C375.44,272,374,298.4,373.09,317.09Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M373.09,317.09c-5.71,5.49-33.13,6.5-47.12-6.82,1.34-9.41.89-19.48,0-29.44s-6.72-27.39,4.4-29.42c14.85-2.9,24.55-2.67,34.48,2.92C375.44,272,374,298.4,373.09,317.09Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M373.09,317.09c-5.71,5.49-33.13,6.5-47.12-6.82,1.34-9.41.89-19.48,0-29.44s-6.72-27.39,4.4-29.42c14.85-2.9,24.55-2.67,34.48,2.92C375.44,272,374,298.4,373.09,317.09Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351,328.92a1.26,1.26,0,0,1,0,.43,0,0,0,0,1,0,0,1.25,1.25,0,0,1-.16.33l0,0a2.21,2.21,0,0,1-.29.33l0,0a3.1,3.1,0,0,1-.44.31l-23.55,13.68a3.79,3.79,0,0,1-.68.3l-.26.08-.34.09-.42.07h-.1l-.57,0H324a5.12,5.12,0,0,1-.56,0h-.09a4.85,4.85,0,0,1-.55-.09l-.1,0-.47-.14-.09,0a3.11,3.11,0,0,1-.52-.25l-38.86-22.43a3.1,3.1,0,0,1-.44-.31l-.11-.12a2.05,2.05,0,0,1-.2-.23,1.09,1.09,0,0,1-.08-.15.91.91,0,0,1-.11-.22.76.76,0,0,1,0-.16,1.43,1.43,0,0,1,0-.22v1.38a1.43,1.43,0,0,0,0,.22.74.74,0,0,0,.14.38,1.09,1.09,0,0,0,.08.15,1.37,1.37,0,0,0,.2.22,1.31,1.31,0,0,0,.11.12,2.49,2.49,0,0,0,.44.32l38.86,22.43a3.11,3.11,0,0,0,.52.25l.09,0,.47.14.1,0a4.85,4.85,0,0,0,.55.09h.09a5.12,5.12,0,0,0,.56,0h.1l.57,0h.1l.42-.08.34-.08.26-.08a3.79,3.79,0,0,0,.68-.3L350,331.77a3.07,3.07,0,0,0,.44-.3,0,0,0,0,1,0,0,2.86,2.86,0,0,0,.29-.33l0,0a1.25,1.25,0,0,0,.16-.33,0,0,0,0,0,0,0,1.16,1.16,0,0,0,0-.32h0v-1.5Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M351,328.92a1.26,1.26,0,0,1,0,.43,0,0,0,0,1,0,0,1.25,1.25,0,0,1-.16.33l0,0a2.21,2.21,0,0,1-.29.33l0,0a3.1,3.1,0,0,1-.44.31l-23.55,13.68a3.79,3.79,0,0,1-.68.3l-.26.08-.34.09-.42.07h-.1l-.57,0H324a5.12,5.12,0,0,1-.56,0h-.09a4.85,4.85,0,0,1-.55-.09l-.1,0-.47-.14-.09,0a3.11,3.11,0,0,1-.52-.25l-38.86-22.43a3.1,3.1,0,0,1-.44-.31l-.11-.12a2.05,2.05,0,0,1-.2-.23,1.09,1.09,0,0,1-.08-.15.91.91,0,0,1-.11-.22.76.76,0,0,1,0-.16,1.43,1.43,0,0,1,0-.22v1.38a1.43,1.43,0,0,0,0,.22.74.74,0,0,0,.14.38,1.09,1.09,0,0,0,.08.15,1.37,1.37,0,0,0,.2.22,1.31,1.31,0,0,0,.11.12,2.49,2.49,0,0,0,.44.32l38.86,22.43a3.11,3.11,0,0,0,.52.25l.09,0,.47.14.1,0a4.85,4.85,0,0,0,.55.09h.09a5.12,5.12,0,0,0,.56,0h.1l.57,0h.1l.42-.08.34-.08.26-.08a3.79,3.79,0,0,0,.68-.3L350,331.77a3.07,3.07,0,0,0,.44-.3,0,0,0,0,1,0,0,2.86,2.86,0,0,0,.29-.33l0,0a1.25,1.25,0,0,0,.16-.33,0,0,0,0,0,0,0,1.16,1.16,0,0,0,0-.32h0v-1.5Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.77,320.62a.91.91,0,0,0,.11.22,1.09,1.09,0,0,0,.08.15,2.05,2.05,0,0,0,.2.23l.11.12a3.1,3.1,0,0,0,.44.31l38.86,22.43a3.11,3.11,0,0,0,.52.25l.09,0,.47.14.1,0a4.85,4.85,0,0,0,.55.09h.09a5.12,5.12,0,0,0,.56,0h.1l.57,0h.1l.42-.07.34-.09.26-.08a3.79,3.79,0,0,0,.68-.3L350,330.4a3.1,3.1,0,0,0,.44-.31l0,0a2.21,2.21,0,0,0,.29-.33l0,0a1.25,1.25,0,0,0,.16-.33,0,0,0,0,0,0,0,1.26,1.26,0,0,0,0-.43,1.75,1.75,0,0,0-1-1.33l-38.86-22.43a5.28,5.28,0,0,0-4.83,0L282.7,318.84a1.73,1.73,0,0,0-1,1.4,1.43,1.43,0,0,0,0,.22A.76.76,0,0,0,281.77,320.62Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285,320.24,322.76,342l.14.07.09,0,.29.09.21,0h.14l.37,0h0a2.75,2.75,0,0,0,.39,0l.25,0,.3-.08a1.19,1.19,0,0,0,.26-.11L337.38,335l-39-22.51Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M324,342.3h0Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.92,314.25l-7.1,4.18a.71.71,0,0,0,0,1.24l10.62,6.13a1.18,1.18,0,0,0,1.19,0l7.1-4.17a.72.72,0,0,0,0-1.24l-10.62-6.14A1.18,1.18,0,0,0,320.92,314.25Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M285,320.24,322.76,342l.14.07.09,0,.29.09.21,0h.14l.37,0h0a2.75,2.75,0,0,0,.39,0l.25,0,.3-.08a1.19,1.19,0,0,0,.26-.11L337.38,335l-39-22.51Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M320.92,314.25l-7.1,4.18a.71.71,0,0,0,0,1.24l10.62,6.13a1.18,1.18,0,0,0,1.19,0l7.1-4.17a.72.72,0,0,0,0-1.24l-10.62-6.14A1.18,1.18,0,0,0,320.92,314.25Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.76,342.69l-4-25.58a4.7,4.7,0,0,0-2.29-3.35L278.32,291a1.17,1.17,0,0,0-1-.07h0l-.93.46.31.12a1.14,1.14,0,0,0-.1.69l4,25.59a4.7,4.7,0,0,0,2.29,3.34L322,343.89a1.45,1.45,0,0,0,.26.11l0,.37.9-.44h0A1.17,1.17,0,0,0,323.76,342.69Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M323.76,342.69l-4-25.58a4.7,4.7,0,0,0-2.29-3.35L278.32,291a1.17,1.17,0,0,0-1-.07h0l-.93.46.31.12a1.14,1.14,0,0,0-.1.69l4,25.59a4.7,4.7,0,0,0,2.29,3.34L322,343.89a1.45,1.45,0,0,0,.26.11l0,.37.9-.44h0A1.17,1.17,0,0,0,323.76,342.69Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.66,314.15,277.53,291.4a1.18,1.18,0,0,0-1.76,1.21l4,25.58a4.78,4.78,0,0,0,2.3,3.35l39.13,22.75a1.18,1.18,0,0,0,1.76-1.21l-4-25.58A4.74,4.74,0,0,0,316.66,314.15Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M297.7,314.81a8.66,8.66,0,0,1,3.88,5.6c.26,2-1.06,2.74-3,1.64a8.64,8.64,0,0,1-3.88-5.59C294.48,314.46,295.81,313.73,297.7,314.81Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M382.05,298.34l-4.2-15.62L363.12,286l3.53,12.11-21.59,15.33-7.26,3.06a11.4,11.4,0,0,0-4.81,3.82l-5.92,8.2a.68.68,0,0,0-.06.35,1.13,1.13,0,0,0,2,.54c1.31-1.5,2.41-2.89,3.78-4.2l-3.49,4.71a1.41,1.41,0,0,0,.44,2,5.42,5.42,0,0,0,1.26.55,5.32,5.32,0,0,0,4.9-1.23l4.57-4.19,1.26-.44a19.14,19.14,0,0,0,9.18-6.89l25.31-9.83A9.67,9.67,0,0,0,382.05,298.34Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M382.05,298.34l-4.2-15.62L363.12,286l3.53,12.11-21.59,15.33-7.26,3.06a11.4,11.4,0,0,0-4.81,3.82l-5.92,8.2a.68.68,0,0,0-.06.35,1.13,1.13,0,0,0,2,.54c1.31-1.5,2.41-2.89,3.78-4.2l-3.49,4.71a1.41,1.41,0,0,0,.44,2,5.42,5.42,0,0,0,1.26.55,5.32,5.32,0,0,0,4.9-1.23l4.57-4.19,1.26-.44a19.14,19.14,0,0,0,9.18-6.89l25.31-9.83A9.67,9.67,0,0,0,382.05,298.34Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M380.16,284.76l-.45-2.07c-5.35-24.32-9.62-26.05-16.79-29.38-7,6.08-5.81,16.42-5.81,16.42l6.25,18.71.19.54A21.75,21.75,0,0,0,380.16,284.76Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M380.16,284.76l-.45-2.07c-5.35-24.32-9.62-26.05-16.79-29.38-7,6.08-5.81,16.42-5.81,16.42l6.25,18.71.19.54A21.75,21.75,0,0,0,380.16,284.76Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M352.94,233.85a44.24,44.24,0,0,0,2.33-13.68c0-2.48-.25-5.19-2-7-2.09-2.14-5.67-2.12-8.34-.77s-4.63,3.74-6.51,6.06a54.93,54.93,0,0,0,4.12,11.72c.94,1.82,2.08,3.67,3.9,4.6S351.32,235.11,352.94,233.85Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M339.73,262.42c-3.59,2.27-8.25-1.94-4.08-8.08a.22.22,0,0,0,.05-.11V244l13.54-7.47.31,13.67C348.1,254.43,342.85,260.44,339.73,262.42Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M339.73,262.42c-3.59,2.27-8.25-1.94-4.08-8.08a.22.22,0,0,0,.05-.11V244l13.54-7.47.31,13.67C348.1,254.43,342.85,260.44,339.73,262.42Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M342.67,247.27c-2.26,1.09-5.08,2.19-7,2.9V244l13.54-7.47C349.13,243.3,346.43,245.45,342.67,247.27Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M323.88,217.76a114.86,114.86,0,0,0,.28,20.23A10,10,0,0,0,336,246.81c2.22-.46,4.34-1,6.14-1.47a9.23,9.23,0,0,0,6.56-6.76l.5-2.08a4.25,4.25,0,0,0,5.12,1.2,5.73,5.73,0,0,0,3.25-4.41,5.3,5.3,0,0,0-.24-2.79,3.67,3.67,0,0,0-1.88-2,4.09,4.09,0,0,0-4.51,1.29,8.68,8.68,0,0,0-1.82,4.6,14.19,14.19,0,0,1-3.56-10.24,5.11,5.11,0,0,1-3.28-1.68,4.46,4.46,0,0,1-.84-3.33C336.15,221.79,328.85,221.07,323.88,217.76Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M323.88,217.76a114.86,114.86,0,0,0,.28,20.23A10,10,0,0,0,336,246.81c2.22-.46,4.34-1,6.14-1.47a9.23,9.23,0,0,0,6.56-6.76l.5-2.08a4.25,4.25,0,0,0,5.12,1.2,5.73,5.73,0,0,0,3.25-4.41,5.3,5.3,0,0,0-.24-2.79,3.67,3.67,0,0,0-1.88-2,4.09,4.09,0,0,0-4.51,1.29,8.68,8.68,0,0,0-1.82,4.6,14.19,14.19,0,0,1-3.56-10.24,5.11,5.11,0,0,1-3.28-1.68,4.46,4.46,0,0,1-.84-3.33C336.15,221.79,328.85,221.07,323.88,217.76Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "313.65 186.17 308.95 191.86 313.26 193.39 313.65 186.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "313.65 186.17 308.95 191.86 313.26 193.39 313.65 186.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M336.89,239.13l-3.63,1.11a2.24,2.24,0,0,0,2.45,1.13A2,2,0,0,0,336.89,239.13Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M336.89,239.13l-3.63,1.11a2.24,2.24,0,0,0,2.45,1.13A2,2,0,0,0,336.89,239.13Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M334.52,241.3a2.11,2.11,0,0,0,1.19.07,1.83,1.83,0,0,0,1.18-1.64,2.22,2.22,0,0,0-1.41.25A2.18,2.18,0,0,0,334.52,241.3Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M339.73,230.33a1.29,1.29,0,1,1-1.22-1.36A1.29,1.29,0,0,1,339.73,230.33Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M328.93,229.33a1.29,1.29,0,1,1-1.22-1.35A1.29,1.29,0,0,1,328.93,229.33Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M328,224.14,325,226a1.85,1.85,0,0,1,.67-2A2.16,2.16,0,0,1,328,224.14Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M339,224.57l2.76,2.13a1.86,1.86,0,0,0-.45-2A2.23,2.23,0,0,0,339,224.57Z",
    transform: "translate(-19.69 -42.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M342.06,218.68a4.48,4.48,0,0,1-1.24,2.41,3.52,3.52,0,0,1-2.54,1,2.8,2.8,0,0,1-2.34-1.35,3.31,3.31,0,0,1-3.05,1.35,3.67,3.67,0,0,1-2.94-1.92,3.48,3.48,0,0,1-3.62,1.42,3.33,3.33,0,0,1-2.47-2.89,4.33,4.33,0,0,1-3.23-.46,3.19,3.19,0,0,1-1.54-2.8,2.56,2.56,0,0,1,2-2.35,3.36,3.36,0,0,1,.84-4A3.29,3.29,0,0,1,326,209a2.59,2.59,0,0,1,1.53-2.29,2.55,2.55,0,0,1,2.7.52,4.07,4.07,0,0,1,7.55-1.63,3.52,3.52,0,0,1,3.28-1.75,3.29,3.29,0,0,1,2.84,2.17,4.08,4.08,0,0,1,7.48,2,2.52,2.52,0,0,1,3.47.2,3.15,3.15,0,0,1,.29,3.61,4.16,4.16,0,0,1-3.18,1.93,3.28,3.28,0,0,1-5.64,3.23,2.43,2.43,0,0,1-1.55,2.58A2.27,2.27,0,0,1,342.06,218.68Z",
    transform: "translate(-19.69 -42.91)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/heroImage.083772fe1c006e0cb537dcd6389a90b5.svg";
export { ForwardRef as ReactComponent };